export default __webpack_public_path__ + "static/icon-14-4-b9d31d3183161fc60a197aa0c9fc5c25.png";